import { checkEqual, notContainsOnlySpaces } from "../../../utils";

export const refusedToUpdate = (id, statusEdited) => {
  if (id && statusEdited) {
    return true;
  }
  return false;
};

export const isDisableSubmit = (state, statechange) => {
  if (state) {
    return refusedToUpdate(state?.id, checkEqual(state, statechange));
  } else {
    if (statechange?.name) {
      return !notContainsOnlySpaces(statechange?.name);
    }
    if (statechange?.partnerName) {
      return !notContainsOnlySpaces(statechange?.partnerName);
    }
  }
};

export const isOpenPopup = true;
